// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.I2cng_BH4aIxH9g9JlpX{flex-direction:column;height:100%;padding:0 20px;display:flex}.OQfowXJT6MgecuXx5Ao9{flex-shrink:0;justify-content:space-between;margin:28px 0 16px;display:flex}.AAWPFZ_2Uk3FEa5QSFmY{flex-shrink:0;margin-top:-4px;margin-left:-4px}.Hj7DseGxAILQRIuWDyhR{flex-direction:column;flex:1;min-height:0;margin-left:-4px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `I2cng_BH4aIxH9g9JlpX`,
	"actionsContainer": `OQfowXJT6MgecuXx5Ao9`,
	"search": `AAWPFZ_2Uk3FEa5QSFmY`,
	"tableContainer": `Hj7DseGxAILQRIuWDyhR`
};
export default ___CSS_LOADER_EXPORT___;
